import React from 'react'
import { useLocation } from 'react-router-dom';
import Breadcrumbs from '../../layout/breadcrumb';
import DprHeader from '../../layout/dprHeader';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import Observation from './observation/observation';
import LogIncident from './log-Incident/log-Incident';
import SOPSafetyList from './sop-safety/sop-safety';
import JobSpecific from './Job-specific-training/Job-specific-training';
import ConsequenceManagement from './consequence-management/consequence-management';
import ToolBoxTalk from './tool-box-talk/tool-box-talk';
import WorkPermit from './work-permit/work-permit';

export default function Saftey() {
  const location = useLocation();
  const data = location.state || {};
  return <React.Fragment>
    <div className='pb-5'>
      <Breadcrumbs title="Safety" menu="" link="Safety" />
      <DprHeader project={data} />
      <div className='card mt-4 card-none-b'>
        <div className='card-body'>
          <Tabs>
            <div className='row' id='risk-register' style={{ marginLeft: 10, marginRight: 10 }}>
              <div className='col-12'>
                <TabList>
                  <Tab >Log Observation</Tab>
                  <Tab >Log Incident information</Tab>
                  {/* <Tab >SOP Safety </Tab>
                  <Tab >Job specific training</Tab>
                  <Tab >Consequence Management</Tab>
                  <Tab >Toolbox talk</Tab>
                  <Tab >Work Permit</Tab> */}
                </TabList>
              </div>
              <hr />
            </div>
            <div className='row' style={{ marginLeft: 20 }}>
              <TabPanel>
                <Observation data={data} />
              </TabPanel>
              <TabPanel>
                <LogIncident data={data} />
              </TabPanel>
              {/* <TabPanel>
                <SOPSafetyList />
              </TabPanel>
              <TabPanel>
                <JobSpecific data={data} />
              </TabPanel>
              <TabPanel>
                <ConsequenceManagement data={data} />
              </TabPanel>
              <TabPanel>
                <ToolBoxTalk data={data} />
              </TabPanel>
              <TabPanel>
                <WorkPermit data={data} />
              </TabPanel> */}
            </div>
          </Tabs>
        </div>
      </div>
    </div>
  </React.Fragment>
}
